var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrompt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 17.1663C2.87508 17.1663 2.48272 17.0031 2.15633 16.6768C1.82994 16.3504 1.66675 15.958 1.66675 15.4997V5.49967C1.66675 5.04134 1.82994 4.64898 2.15633 4.32259C2.48272 3.9962 2.87508 3.83301 3.33341 3.83301H16.6667C17.1251 3.83301 17.5174 3.9962 17.8438 4.32259C18.1702 4.64898 18.3334 5.04134 18.3334 5.49967V15.4997C18.3334 15.958 18.1702 16.3504 17.8438 16.6768C17.5174 17.0031 17.1251 17.1663 16.6667 17.1663H3.33341ZM3.33341 15.4997H16.6667V7.16634H3.33341V15.4997ZM6.25008 14.6663L5.08341 13.4997L7.22925 11.333L5.06258 9.16634L6.25008 7.99967L9.58341 11.333L6.25008 14.6663ZM10.0001 14.6663V12.9997H15.0001V14.6663H10.0001Z",
    fill: "#010610"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrompt);
export default __webpack_public_path__ + "static/media/Prompt.89a1523d0b8a8c960f5465a66a6e9944.svg";
export { ForwardRef as ReactComponent };